import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { VideoPlayCountApi, VideoPlayHistoryApi } from '../../apis'
import { AppState } from '../../reducers'
import { PlayCountService } from './base'

@Injectable()
export class VideoPlayCountService extends PlayCountService{
  constructor(protected api: VideoPlayCountApi) {
    super(api)
  }
}



// WEBPACK FOOTER //
// ./src/services/play-count/video.ts